<template>
    <div>

    <script type="application/javascript">

            function newCallFakeBookingMutate(slot, user, dayDate){

                alert(`object: ${JSON.stringify(slot)}`)

                return 'No Error';

            try{    
                    const data:{

                        const email:
    
                             userId: user.id,
                        
                             userPoints: user.coins,

                             slotId: slot.id,
                        
                             points: slot.points_cost,

                             dayDate:  dayDate,

                             businessId: slot.class.business.id

                            classId: slot.class.id,
                    }

                    alert(`successfully Sending: ${JSON.stringify(data)}`)

                    let result = await axios({method: 'post',url: '/pnadiapi/fakeBookings/bookSession',
                        data: {
                        
                            slot: slot
                        }});
                }catch(error){

                    alert(`error: ${error}`);
                }

        return 'no error';
      }
        </script>
    </div>
</template>

<script>

import myQueries from '../hasura/myQueries';
import myInserts from '../hasura/myInserts';
import mySubscriptions from '../hasura/mySubscriptions';

import moment from 'moment';

import componentsHelpers from '../classes/componentHelpers';

import Vue from 'vue';

// import axios from '@/classes/myAxios'
import axios from '@/classes/myAxios'




// var viewModel = new Vue({
// 	el: "#app",
//   data: {
//   	msg: "Hello there"
//   },
//   methods: {
//     test: function() {
//       alert('test fuction called');
//     }
//   }
// });

// viewModel.test();



export default {
    
    mounted(){

        // Event.$on("fetchdata", group => {

        //     console.log("in event.on");

        // });

    EventBus.$on('callFakeBookingMutate', function (payLoad) {
              
                console.log("in event.on");
              this.fakeBookingMutate();
            });
    },

    methods:{

        fakeBookingMutate(value1, value2, value3){

            console.log(`in fakeBookingMutate, with ${value1}, ${value2}, ${value3}`);
            
            console.log(`my value: ${this.myValue}`);

            // alert(`in fakeBookingMutate`);
        }
        
        // increment() {
        //     this.count++;
        // }
    },

        data: function () {
        return {
            
            myValue: "Hi"
            // count: 0,
        };
    }
}

//  function callFakeBookingMutate(value1, value2, value3){


//                 console.log(`in callFakeBookingMutate`);
                
//                 alert(`in callFakeBookingMutate`);


//                 vm['secondSlotsChild'].fakeBookingMutate(value1, value2, value3); // This doesn't work

//             // Vue.$refs.secondSlotsChildRef.fakeBookingMutate(value1, value2, value3);
//         }



// let vm2 = Vue.component('secondSlotsChild', {

// // var vm = new Vue.component('secondSlotsChild', {
//     template: `
//        <div>
//         </div>
//       `,

//     methods: {

//         mounted(){

//             console.log(`mounteed, in secondSlotChilds`);
//         },

//         fakeBookingMutate(value1, value2, value3){

//             console.log(`in fakeBookingMutate, with ${value1}, ${value2}, ${value3}`);
            
//             alert(`in fakeBookingMutate`);
//         }
        
//         // increment() {
//         //     this.count++;
//         // }
//     },

//         data: function () {
//         return {
            
//             // count: 0,
//         };
//     },
// })

// function callFakeBookingMutate(value1, value2, value3){

//         console.log(`in callFakeBookingMutate`);
        
//         // alert(`in callFakeBookingMutate`);


//         // vm2['secondSlotsChild'].fakeBookingMutate(value1, value2, value3); // This doesn't work

//     vm2.fakeBookingMutate(value1, value2, value3);
// }


// callFakeBookingMutate('test1', 'test2', 'test3');

// console.log(`in secondSlotChilds`);

</script>

